import { FormLayoutContainer } from '../../containers/FormLayoutContainer';
import { QuestionLayoutContainer } from '../../containers/QuestionLayoutContainer';
export var FORM_COMPONENTS = {
  WidgetLayoutComponent: FormLayoutContainer,
  QuestionLayoutComponent: QuestionLayoutContainer
};